import type { LocationQuery, RouteLocation, Router } from "vue-router";

import RouteHelper from "@/common/route-helper";
import { QUERY_SEARCH_DIRECTION_KEY, QUERY_SEARCH_WORD_KEY } from "@/router/query-params";
import { ROUTER_PARAM_LANGUAGE, ROUTER_PARAM_PACKAGE_GROUP } from "@/router/router-params";
import { useSettingsStore } from "@/stores";

export const useSearchRoute = (router: Router) => {
  const getSearchRoute = (
    searchWord: string,
    direction: string | undefined = undefined
  ): RouteLocation => {
    const routeHelper = new RouteHelper(router);
    const settingsStore = useSettingsStore();

    const queryParameters: LocationQuery = {
      [QUERY_SEARCH_WORD_KEY]: searchWord
    };

    if (direction) {
      queryParameters[QUERY_SEARCH_DIRECTION_KEY] = direction;
    }

    const routeParams = {
      [ROUTER_PARAM_LANGUAGE]: settingsStore.activeLanguageGroup,
      [ROUTER_PARAM_PACKAGE_GROUP]: settingsStore.preferredPackageGroup?.id
    };

    // On an article and changing package could cause this to be empty.
    if (!routeParams[ROUTER_PARAM_LANGUAGE]) {
      return router.resolve({ name: "dictionary" });
    }

    return router.resolve({
      name: "article",
      params: routeParams,
      query: routeHelper.getQueryParams(queryParameters)
    });
  };

  return {
    getSearchRoute
  };
};
